import { Directive, ElementRef, HostListener } from '@angular/core';


@Directive({
  selector: 'ion-searchbar[select-all],ion-input[select-all]'
})
export class SelectAllDirective {

  constructor(private el: ElementRef) {}

  @HostListener('click')

  selectAll() {

    // acceso al elemento input nativo
    let nativeEl: HTMLInputElement = this.el.nativeElement.querySelector('input');

    if (nativeEl) {

      if (nativeEl.setSelectionRange) {

        // selecciona el texto desde inicio a fin
        return nativeEl.setSelectionRange(0, nativeEl.value.length);
      }

      nativeEl.select();
    }
  }

}



// WEBPACK FOOTER //
// ./src/directives/select-all/select-all.ts